import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { postJwtLogin } from "../../../helpers/fakebackend_helper"
import axiosApi from "helpers/api_helper"

// Thunk de logout
export const logoutUser = createAsyncThunk(
  "auth/logoutUser",
  async (history, { rejectWithValue }) => {
    try {
      // Supprimer les jetons de stockage local
      localStorage.removeItem("auth_token")
      localStorage.removeItem("ref_token")
      delete axiosApi.defaults.headers.common["Authorization"]
      history("/login") // Rediriger vers la page de connexion
    } catch (error) {
      return rejectWithValue(error.message)
    }
  }
)

// Thunk de refresh
export const refresh = createAsyncThunk(
  "auth/refresh",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosApi.post("/player/refreshToken", {
        refreshToken: localStorage.getItem("ref_token"),
      })
      // on attend { accessToken, refreshToken? }
      const { accessToken: newAccess, refreshToken: newRefresh } = response.data

      // mettre à jour storage
      localStorage.setItem("auth_token", newAccess)
      if (newRefresh) {
        localStorage.setItem("ref_token", newRefresh)
      }

      // mettre à jour l'en‑tête
      axiosApi.defaults.headers.common["Authorization"] = `Bearer ${newAccess}`

      return newAccess
    } catch (error) {
      console.log("error : ", error);
      return rejectWithValue(error.message)
    }
  }
)

const initialState = {
  user: null,
  loading: false,
  error: null,
}

const loginSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // refresh
      .addCase(refresh.pending, (state) => {
        state.loading = true // Mettre loading à true lors du refresh
      })
      .addCase(refresh.fulfilled, (state) => {
        state.loading = false // Réinitialiser loading après un refresh réussi
      })
      .addCase(refresh.rejected, (state) => {
        state.loading = false
        state.user = null // Déconnecter l'utilisateur si le refresh échoue
      })
      // logout
      .addCase(logoutUser.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(logoutUser.fulfilled, (state) => {
        state.loading = false
        state.user = null // Réinitialiser l'état utilisateur après déconnexion
      })
      .addCase(logoutUser.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
  },
})

export default loginSlice.reducer
